"use strict";

/**
 * Clase Notification para manejar alertas y notificaciones.
 */
export class Notification {
    /**
     * Muestra una alerta informativa grande utilizando SweetAlert.
     * @param {string} confirmButtonColor - Color del botón de confirmación.
     * @param {string} html - Contenido HTML de la alerta.
     * @param {string} icon - Icono de la alerta.
     * @param {string} title - Título de la alerta.
     */
    showSwal(confirmButtonColor, html, icon, title) {
        Swal.fire({
            backdrop: "rgba(0, 0, 0, 0.95)",
            background: "#FFFFFF",
            confirmButtonColor: confirmButtonColor,
            customClass: "md:w-1/2 w-11/12",
            html: html,
            icon: icon,
            title: title,
        });
    }

    /**
     * Muestra una alerta de confirmación grande utilizando SweetAlert.
     * @param {string} cancelButtonText - Texto del botón de cancelación.
     * @param {string} confirmButtonColor - Color del botón de confirmación.
     * @param {string} confirmButtonText - Texto del botón de confirmación.
     * @param {string} html - Contenido HTML de la alerta.
     * @param {string} icon - Icono de la alerta.
     * @param {string} title - Título de la alerta.
     * @returns {Promise} Promesa que se resuelve cuando se cierra la alerta.
     */
    showSwalConfirm(
        cancelButtonText,
        confirmButtonColor,
        confirmButtonText,
        html,
        icon,
        title
    ) {
        return Swal.fire({
            cancelButtonColor: "#837f7e",
            cancelButtonText: cancelButtonText,
            confirmButtonColor: confirmButtonColor,
            confirmButtonText: confirmButtonText,
            customClass: "md:w-1/2 w-11/12",
            focusConfirm: false,
            html: html,
            icon: icon,
            showCancelButton: true,
            showCloseButton: true,
            title: title,
        });
    }

    /**
     * Muestra una alerta informativa pequeña utilizando Toasted.
     * @param {string} theme - Color de fondo de la notificación.
     * @param {string} type - Tipo de notificación.
     * @param {string} message - Mensaje de la notificación.
     */
    showToasted(theme, type, message) {
        const toasted = new Toasted({
            duration: 5000,
            position: "bottom-left",
            theme: theme,
            type: type,
        });

        toasted.show(message);
    }
}
